export default function NewTag() {
    return <span className={"finish-details__new-pill"}>{window.steelcase_i18n["steelcase-finish-library"].New || "New"}</span>
}